/**
 * Единый вид заплаток поверх PNG — ровные карточки, не «лужицы».
 */

const NAVY_16 = 'rgba(27, 42, 107, 0.2)'
const NAVY_06 = 'rgba(27, 42, 107, 0.06)'

const patchGpuPolish = {
  transform: 'translateZ(0)',
  WebkitBackdropFilter: 'blur(14px) saturate(1.2)',
  backdropFilter: 'blur(14px) saturate(1.2)',
  backgroundColor: 'rgba(255,255,255,0.75)',
}

/** Крупные блоки: заголовок, абзацы, шаги */
export function patchPanel(bg) {
  return {
    position: 'absolute',
    zIndex: 2,
    boxSizing: 'border-box',
    backgroundColor: bg,
    borderRadius: 14,
    border: `1px solid ${NAVY_16}`,
    boxShadow: `0 2px 12px ${NAVY_06}, inset 0 1px 0 rgba(255, 255, 255, 0.65)`,
    overflow: 'hidden',
    ...patchGpuPolish,
  }
}

/**
 * Плашки поверх PNG со встроенным текстом: плотный фон без «стекла»,
 * чтобы старые надписи не просвечивали.
 */
export function patchPanelMask(bg) {
  return {
    position: 'absolute',
    zIndex: 2,
    boxSizing: 'border-box',
    borderRadius: 12,
    border: '1px solid rgba(27, 42, 107, 0.28)',
    boxShadow: '0 1px 8px rgba(0, 0, 0, 0.05)',
    overflow: 'hidden',
    ...patchGpuPolish,
    backgroundColor: bg,
  }
}

/** Средние: подзаголовки секций */
export function patchBand(bg) {
  return {
    position: 'absolute',
    zIndex: 2,
    boxSizing: 'border-box',
    backgroundColor: bg,
    borderRadius: 10,
    border: `1px solid ${NAVY_16}`,
    boxShadow: `0 1px 8px ${NAVY_06}, inset 0 1px 0 rgba(255, 255, 255, 0.55)`,
    overflow: 'hidden',
    ...patchGpuPolish,
  }
}

/** Мелкие: подписи у осей, короткие лейблы */
export function patchChip(bg) {
  return {
    position: 'absolute',
    zIndex: 2,
    boxSizing: 'border-box',
    backgroundColor: bg,
    borderRadius: 8,
    border: `1px solid rgba(27, 42, 107, 0.16)`,
    boxShadow: `0 1px 6px ${NAVY_06}, inset 0 1px 0 rgba(255, 255, 255, 0.5)`,
    overflow: 'hidden',
    ...patchGpuPolish,
  }
}
